import { Sparkle } from "lucide-react";

const ITEMS = [
  "Free shipping over ₹999",
  "7-day easy returns",
  "15,000+ happy customers",
  "Secure UPI & COD payments",
  "Ships across India",
  "Quality checked, always",
];

export default function Marquee() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-neutral-800 bg-neutral-900 py-4">
      <div className="animate-marquee flex w-max items-center">
        {loop.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap font-serif text-base italic text-white/75 sm:text-lg">{item}</span>
            <Sparkle size={13} className="mx-8 shrink-0 text-white/30" />
          </span>
        ))}
      </div>
    </div>
  );
}
